import React, { ReactNode } from 'react';

import { Card } from 'antd';

interface SectionCardProps {
  children: ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

/**
 * Reusable wrapper Card component with consistent styling for sections.
 * Used to wrap TelemetrySection, SecurityCodeSection, and AssistanceSection.
 */
export const SectionCard = ({
  children,
  className,
  style,
}: SectionCardProps) => (
  <Card
    className={className}
    style={{
      background: '#FAFBFB',
      marginTop: '16px',
      ...style,
    }}
    styles={{
      body: {
        padding: '0.75rem',
      },
    }}
  >
    {children}
  </Card>
);
